@if(!noResultsSeries) {
    <div class="series-card mt-3 bg-white grid gap-4 grid-cols-2 md:grid-cols-6 text-sm lg:text-lg"
        data-cy="seriesCard">
        @let summary = seriesSummary();
        @let summaryItemsCurrencyFormat = [
            { property: summary?.commitment, label: 'Commitments', dataCy: 'commitmentsLabel' },
            { property: summary?.contributions, label: 'Contributions', dataCy: 'contributionsLabel' },
            { property: summary?.distributions, label: 'Distributions', dataCy: 'distributionsLabel' },
            { property: summary?.nav, label: 'Net Asset Value', dataCy: 'navLabel' }
        ];
        @for(item of summaryItemsCurrencyFormat; track item.label) {
            <div class="info-div justify-self-center md:justify-self-start" >
                <h2 class="card-value" data-cy="balanceValue">
                    {{item.property | currencyFormat:currency()}}
                </h2>
                <p class="card-label" attr.data-cy="{{item.dataCy}}">{{item.label}}</p>
            </div>
        }
        <div class="info-div justify-self-center md:justify-self-start ml-16 md:ml-5">
            <h2 class="card-value flex justify-center" data-cy="tvpi"
                [ngClass]="{'pr-6': !summary?.tvpiIcon}">
                {{summary?.tvpi | tvpiValueFormat}}
                @if(summary?.tvpiIcon) {
                    <div class="ml-2 lg:mt-1">
                        <img data-cy="tvpiIcon" src="{{summary?.tvpiIcon}}" alt="{{summary?.tvpiTitle}}"
                            [matTooltip]="summary?.tvpiTitle" matTooltipClass="blue-tooltip"
                            matTooltipPosition="right">
                    </div>
                }
            </h2>
            <p class="card-label mr-6" data-cy="investmentTvpiLabel">Investment TVPI</p>
        </div>
        <div class="info-div justify-self-center md:justify-self-start ml-16 md:ml-5 mb-3 md:mb-0">
            <h2 class="card-value flex justify-center" data-cy="irr"
                [ngClass]="{'pr-6': !summary?.irrIcon}">
                {{summary?.irr | irrValueFormat}}
                @if(summary?.irrIcon) {
                    <div class="ml-2 lg:mt-1">
                        <img data-cy="irrIcon" src="{{summary?.irrIcon}}" alt="{{summary?.irrTitle}}"
                            [matTooltip]="summary?.irrTitle" matTooltipClass="blue-tooltip"
                            matTooltipPosition="right">
                    </div>
                }
                
            </h2>
            <p class="card-label mr-6" data-cy="investmentIrrLabel">Investment IRR</p>
        </div>
    </div>
}
@else {
    <div class="series-card mt-3 no-result-text bg-white" data-cy="seriesNoResult">
        No Results
    </div>
}
